// import { productSchema } from './schemas'
// import { normalize } from 'normalizr'
// import merge from "lodash/object/merge"

import {
  PRODUCT_BY_ID,
  PRODUCT_BY_ID_SUCCESS,
  PRODUCT_BY_ID_FAILURE,
  ALL_PRODUCTS,
  ALL_PRODUCTS_SUCCESS,
  ALL_PRODUCTS_FAILURE,
  AUTH_SUCCESS,
  AUTH_FAILURE,
  ERROR_MSG,
  HOMEPAGE_CONTENT,
  HOMEPAGE_CONTENT_SUCCESS,
  HOMEPAGE_CONTENT_FAILURE,
  ALL_NAVIGATION,
  ALL_NAVIGATION_SUCCESS,
  ALL_NAVIGATION_FAILURE,
  CONTENT_PAGE,
  CONTENT_PAGE_SUCCESS,
  CONTENT_PAGE_FAILURE,
} from './mutation-types';

export const productMutations = {
  [ALL_PRODUCTS](state) {
    state.isError = false;
    state.showLoader = true;
  },
  [ALL_PRODUCTS_SUCCESS](state, payload) {
    state.showLoader = false;
    state.products = payload;
  },
  [ALL_PRODUCTS_FAILURE](state) {
    state.showLoader = false;
    state.isError = true;
  },
  [PRODUCT_BY_ID](state) {
    state.isError = false;
    state.showLoader = true;
  },
  [PRODUCT_BY_ID_SUCCESS](state, payload) {
    state.showLoader = false;
    state.product = payload;
  },
  [PRODUCT_BY_ID_FAILURE](state) {
    state.showLoader = false;
    state.isError = true;
  },
  [ERROR_MSG](state, payload) {
    console.debug('state', state);
    console.debug('payload', payload);
  },
};

export const authorisationMutations = {
  [AUTH_SUCCESS](state, token) {
    state.isError = false;
    localStorage.setItem('token', token);
    state.token = token;
  },
  [AUTH_FAILURE](state) {
    state.isError = true;
    localStorage.setItem('token', null);
  },
};

export const contentMutations = {
  [HOMEPAGE_CONTENT](state) {
    state.isError = false;
    state.showLoader = true;
  },
  [HOMEPAGE_CONTENT_SUCCESS](state, payload) {
    state.showLoader = false;
    state.pageContent = payload;
    state.currentPage = payload.slug;
  },
  [HOMEPAGE_CONTENT_FAILURE](state) {
    state.showLoader = false;
    state.isError = true;
  },
  [ALL_NAVIGATION](state) {
    state.isError = false;
    state.showLoader = true;
  },
  [ALL_NAVIGATION_SUCCESS](state, payload) {
    state.showLoader = false;
    state.topNavigation = payload.filter(x => x.isSideMenuItem === false);
    state.sideNavigation = payload.filter(x => x.isSideMenuItem === true);
  },
  [ALL_NAVIGATION_FAILURE](state) {
    state.showLoader = false;
    state.isError = true;
  },
  [CONTENT_PAGE](state) {
    state.isError = false;
    state.showLoader = true;
  },
  [CONTENT_PAGE_SUCCESS](state, payload) {
    state.showLoader = false;
    state.pageContent = payload;
    state.currentPage = payload.slug;
  },
  [CONTENT_PAGE_FAILURE](state) {
    state.showLoader = false;
    state.isError = true;
  },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js